import { render } from "./AHS_VDH_MedBoard.vue?vue&type=template&id=a7a5434a"
import script from "./AHS_VDH_MedBoard.vue?vue&type=script&lang=js"
export * from "./AHS_VDH_MedBoard.vue?vue&type=script&lang=js"

import "./AHS_VDH_MedBoard.vue?vue&type=style&index=0&id=a7a5434a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__